import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { FieldEngineerForm } from '@/components/forms/FieldEngineerForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateFieldEngineerPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/organization/field-engineers')
  }

  const handleCancel = () => {
    navigate('/organization/field-engineers')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Field Engineer</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new Field Engineer profile with location and assignment information
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <FieldEngineerForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
